import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "../axios";
import Currency from "./Currency";
import { useTranslation } from "react-i18next";

const RoomDiningIcon = () => (
  <svg
    className="order2"
    xmlns="http://www.w3.org/2000/svg"
    width="97.944"
    height="88"
    viewBox="0 0 100 100"
  >
    <defs>
      <style></style>
    </defs>
    <g className="cls-1order2">
      <path
        className="cls-2order2"
        d="M112.133,64.585c.064-1.048.129-2.1.266-3.156a62.524,62.524,0,0,1,1.357-7.489c.339-1.224.707-2.433,1.093-3.615.493-1.154.976-2.3,1.457-3.422a29.388,29.388,0,0,1,3.762-5.944c.345-.441.687-.868,1.022-1.3.383-.383.765-.753,1.134-1.124a28.449,28.449,0,0,1,2.231-2.025,29.589,29.589,0,0,1,4.316-2.914,25.2,25.2,0,0,1,3.539-1.769c2.039-.82,3.2-1.233,3.2-1.233s-.987.783-2.711,2.053a37.931,37.931,0,0,0-2.959,2.439,44.826,44.826,0,0,0-3.494,3.414c-.631.629-1.121,1.42-1.717,2.148q-.435.556-.894,1.124c-.248.419-.5.838-.765,1.267a35.723,35.723,0,0,0-2.813,5.552q-.534,1.542-1.084,3.125c-.251,1.1-.529,2.2-.832,3.306a59.751,59.751,0,0,0-1.1,6.957c-.134.862-.2,1.732-.279,2.608,18.892,0,33.514.015,53.974.015.069-.9.108-1.805.108-2.718,0-17.232-12.557-31.424-28.716-33.3a5.35,5.35,0,1,0-7.293,0c-16.157,1.88-28.711,16.072-28.711,33.3,0,.91.033,1.807.1,2.7Z"
        transform="translate(-78.897 -19.328)"
      />
      <rect
        className="cls-2order2"
        width="76.507"
        height="6.749"
        transform="translate(21.437 47.25)"
      />
      <path
        className="cls-2order2"
        d="M110.754,240.978c-3.888,1.889-17.447,6.779-17.447,6.779l-16.027-1S86.447,244.2,90,243.405s2.012-4.809.043-4.809-19.121.708-19.121.708l-11.39,4.1,3.014,19.079s2.345-4.014,4.684-4.014,22.684.541,25.444,0,19.584-12.055,21.6-13.4S114.657,239.086,110.754,240.978Z"
        transform="translate(-44.218 -182.187)"
      />
      <path
        className="cls-2order2"
        d="M0,258.615v24.731l17.45-3.267-4.365-23.766Z"
        transform="translate(0 -195.346)"
      />
    </g>
  </svg>
);

function FnbOrdersSlider({ orders }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const room_uuid = location.pathname.split("/")[1];
  const [loadingOrder, setLoadingOrder] = useState(null);

  const orderAgain = (orderNumber) => {
    setLoadingOrder(orderNumber);
    axios
      .post(`/${room_uuid}/orders/order-again`, { order_number: orderNumber }, { headers: { "Room-Number-From-Dine-in": localStorage.getItem("validated_room_number") } })
      .then((res) => {
        setLoadingOrder(null);
        if (res.data.status) {
          navigate(`/${room_uuid}/Checkout`);
        }
      })
      .catch(() => setLoadingOrder(null));
  };

  const formatOrderType = (type) =>
    type
      .replace(/_order$/, "")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (l) => l.toUpperCase());

  const getStatusStyle = (status) => {
    if (status === "Delivered") return { background: "green" };
    if (status === "Canceled") return { background: "#b11515" };
    if (status === "Processing") return { background: "#005f96" };
    if (status === "Rejected") return { background: "red" };
    return { background: "rgb(250, 97, 35)" };
  };

  const displayOrders = [...(orders || [])];

  return (
    <div className="fnb-orders-slider-section">
      <div className="fnb-orders-slider">
        {displayOrders.map((order, index) => (
          <div
            key={index}
            className="fnb-slide-item"
            style={{ maxWidth: "350px" }}
          >
            <div className="orders" style={{ paddingInline: 0 }}>
              <div className="row">
                <div className="col-12">
                  <svg
                    className="order1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="30"
                    height="58"
                    viewBox="0 0 30 58"
                  >
                    <defs>
                      <style></style>
                      <clipPath id={`clip-path-fnb-${index}`}>
                        <rect
                          className="cls-111"
                          width="30"
                          height="58"
                          rx="10"
                          transform="translate(16 309)"
                        />
                      </clipPath>
                      <filter
                        id={`Path_375-fnb-${index}`}
                        x="-90"
                        y="-44"
                        width="115.014"
                        height="115.014"
                        filterUnits="userSpaceOnUse"
                      >
                        <feOffset dy="3" in="SourceAlpha" />
                        <feGaussianBlur stdDeviation="3" result="blur" />
                        <feFlood floodOpacity="0.161" />
                        <feComposite operator="in" in2="blur" />
                        <feComposite in="SourceGraphic" />
                      </filter>
                    </defs>
                    <g className="cls-211" transform="translate(-16 -309)">
                      <path
                        className="cls-311"
                        d="M48.5,0A48.507,48.507,0,1,1,0,48.5,48.508,48.508,0,0,1,48.5,0Z"
                        transform="translate(-62 270)"
                      />
                      <g transform="matrix(1, 0, 0, 1, 16, 309)">
                        <path
                          className="cls-411"
                          d="M48.5,0A48.507,48.507,0,1,1,0,48.5,48.508,48.508,0,0,1,48.5,0Z"
                          transform="translate(-81 -38)"
                        />
                      </g>
                    </g>
                  </svg>

                  <div className="box" style={{}}>
                    <div className="top">
                      <div className="flex">
                        <div className="top-title">
                          {(() => {
                            const items =
                              order.order_details?.flatMap((d) => d.items) ||
                              [];
                            const visible = items.slice(0, 4);
                            const remaining = items.length - 4;
                            return (
                              <>
                                {visible.map((item, i) => (
                                  <span key={i} style={{ display: "block" }}>
                                    {item.quantity}x {item.name}
                                  </span>
                                ))}
                                {remaining > 0 && (
                                  <span
                                    style={{
                                      display: "block",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    {t("and")} {remaining} {t("more items")}
                                  </span>
                                )}
                              </>
                            );
                          })()}
                        </div>
                        <p className="price" style={{ fontSize: "12px" }}>
                          <Currency currency={order.currency} />
                          {order.price}
                        </p>
                      </div>
                    </div>
                    {/* <div className="middel">
                      <RoomDiningIcon />
                    </div> */}
                    <div className="buttom">
                      <div
                        className="flex"
                        style={{
                          alignItems: "flex-end",
                          justifySelf: "flex-end",
                        }}
                      >
                        <a
                          onClick={() => orderAgain(order.order_number)}
                          className="view"
                          style={{
                            opacity:
                              loadingOrder === order.order_number ? 0.6 : 1,
                            pointerEvents:
                              loadingOrder === order.order_number
                                ? "none"
                                : "auto",
                          }}
                        >
                          {loadingOrder === order.order_number
                            ? t("Loading...")
                            : t("Order Again")}
                        </a>
                      </div>
                    </div>
                  </div>

                  <svg
                    className="order3"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="76"
                    height="68"
                    viewBox="0 0 76 68"
                  >
                    <defs>
                      <style></style>
                      <clipPath id={`clip-path-fnb-r-${index}`}>
                        <rect
                          className="cls-133"
                          width="76"
                          height="68"
                          rx="10"
                          transform="translate(336 356)"
                        />
                      </clipPath>
                      <filter
                        id={`Path_373-fnb-${index}`}
                        x="3"
                        y="4"
                        width="115.014"
                        height="115.014"
                        filterUnits="userSpaceOnUse"
                      >
                        <feOffset dy="3" in="SourceAlpha" />
                        <feGaussianBlur stdDeviation="3" result="blur" />
                        <feFlood floodOpacity="0.161" />
                        <feComposite operator="in" in2="blur" />
                        <feComposite in="SourceGraphic" />
                      </filter>
                    </defs>
                    <g className="cls-233" transform="translate(-336 -356)">
                      <path
                        className="cls-333"
                        d="M48.5,0A48.507,48.507,0,1,1,0,48.5,48.508,48.508,0,0,1,48.5,0Z"
                        transform="translate(345 362)"
                      />
                      <g transform="matrix(1, 0, 0, 1, 336, 356)">
                        <path
                          className="cls-433"
                          d="M48.5,0A48.507,48.507,0,1,1,0,48.5,48.508,48.508,0,0,1,48.5,0Z"
                          transform="translate(12 10)"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FnbOrdersSlider;
